import { Link } from 'react-router-dom';
import { BookOpenIcon, PlusIcon } from 'lucide-react';
import { ProductImage } from '../../ui/ProductImage';
import { PageHeader } from '../ui/PageHeader';
import { Badge } from '../ui/Badge';
import { EmptyState } from '../ui/EmptyState';
import { useAdmin } from '../AdminContext';
import { articleChecks, errorCount } from './catalogRules';
import { btnPrimary, listBox, rowLink } from '../ui/styles';

/** Alle journalartikelen. Het bovenste staat uitgelicht. */
export function Articles() {
  const {
    catalog
  } = useAdmin();
  const newButton = <Link to="/be/journal/nieuw" className={btnPrimary} data-id="element-607" data-mp="3dup3kvoi3nh7">
      <PlusIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-608" data-mp="390uetdu1gib9" />
      Nieuw artikel
    </Link>;
  return <div data-id="element-609" data-mp="3429ktw5dquv9">
      <PageHeader title="Journal" description="Je artikelen. Het bovenste staat uitgelicht op de journalpagina en de homepage." actions={newButton} data-id="element-610" data-mp="340ot0eag9q13" />

      {catalog.articles.length === 0 ? <EmptyState icon={BookOpenIcon} title="Nog geen artikelen" text="Een artikel brengt bezoekers via Google binnen. Begin met de vraag die je het vaakst krijgt." action={newButton} data-id="element-611" data-mp="krha0wn4a0n" /> : <ul className={listBox} data-id="element-612" data-mp="1az9lomvumo0t">
          {catalog.articles.map((a, i) => <li key={a.slug} data-id="element-613" data-mp="1f0bkj2lusy29" data-mpi={i}>
              <Link to={`/be/journal/${a.slug}`} className={rowLink} data-id="element-614" data-mp="1ezjrnzjn5efo">
                <ProductImage src={a.image ?? ''} fit="cover" className="h-14 w-20 shrink-0 rounded" data-id="element-615" data-mp="110trgb1iyyn3" />
                <span className="min-w-0 flex-1" data-id="element-616" data-mp="15zdgikbf0qjo">
                  <span className="block text-[12px] text-clay" data-id="element-617" data-mp="16180nwev4emp">
                    {a.category} · {a.date}
                  </span>
                  <span className="block truncate font-display text-[17px] text-ink" data-id="element-618" data-mp="w1h5dsih9vlk">{a.title || 'Naamloos artikel'}</span>
                  <span className="block truncate text-[13px] text-muted" data-id="element-619" data-mp="2mdde3omsg43r">{a.excerpt}</span>
                </span>
                {i === 0 && <Badge tone="soft" data-id="element-620" data-mp="2qe70ueohvcv2">Uitgelicht</Badge>}
                {errorCount(articleChecks(a)) > 0 && <Badge tone="accent" data-id="element-621" data-mp="383ugt1s1hyh">Nog niet klaar</Badge>}
              </Link>
            </li>)}
        </ul>}
    </div>;
}